<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>类别管理</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
               <el-form-item label="类别编码:" prop="spuCode">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.spuCode"></el-input>
              </el-form-item>
              <el-form-item label="类别名称:" prop="spuName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.spuName"></el-input>
              </el-form-item>
              <el-form-item label="创建人:" prop="createUser">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.createUser"></el-input>
              </el-form-item>
              <el-form-item label="状态:" prop="validFlg">
                <el-select v-model="searchFrom.validFlg" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in statusOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创建时间:" prop="dateTime" >
                <el-date-picker
                  v-model="searchFrom.dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="chaXun" btnCode='000P00JB001' v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="chongZhi" btnCode='000P00JB002' v-if="btnFlg[1]">重置</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary"  @click="addSpuClick" btnCode='000P00JB003' v-if="btnFlg[2]">新增</el-button>
              </el-form-item >
              <el-form-item >
                <el-button type="primary" @click="spuChangeClick" btnCode='000P00JB004' v-if="changeBtnShow && btnFlg[3]">修改</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="spuDelBtnClick" btnCode='000P00JB005' v-if="btnFlg[4]">删除</el-button>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:h}">
      <el-table
        :data="spuTableList"
        ref="spuTableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        @row-click="dianjixuanzhong"
        :row-style="{height:'35px'}"
        @selection-change="selectGoods"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="spuCode"   label="类别编码" align="center"  ></el-table-column>
        <el-table-column prop="spuName"    label="类别名称"  align="center" ></el-table-column>
        <el-table-column property="createUser" label="创建人"  align="center" ></el-table-column>
        <el-table-column prop="createTime"    label="创建时间" align="center" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="validFlg"  label="状态" align="center" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.validFlg =='1'" >启用</span>
            <span v-if="scope.row.validFlg =='0'" >停用</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="180">
          <template slot-scope="scope"><div>
            <el-button  type="text" size="small" @click="seeSkuClick(scope.row)" btnCode='000P00JB006' v-if="btnFlg[5]">查看商品</el-button>
            <el-button type="text" size="small" @click="startOrStopClick(scope.row)" btnCode='000P00JB007' v-if="scope.row.validFlg == '0' && btnFlg[6]">启用</el-button>
            <el-button type="text" size="small" @click="startOrStopClick(scope.row)" btnCode='000P00JB008' v-else-if="scope.row.validFlg == '1' && btnFlg[7]">停用</el-button>
          </div></template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: right;">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="spuTotal">
      </el-pagination>
    </div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>类别属性</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox2" ref="searchBox2">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox" style="margin-left:10px;">
          <el-form-item >
            <el-button type="primary"  @click="addShuXIngClick" btnCode='000P00JB009' v-if="btnFlg[8]" >添加属性</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary"  @click="changeShuXingClick" btnCode='000P00JB00A' v-if="changeShuXiangBtnShow && btnFlg[9]">修改</el-button>
          </el-form-item >
          <el-form-item >
            <el-button type="primary"  @click="delShuXingClick"  btnCode='000P00JB00B' v-if="changeShuXiangBtnShow && btnFlg[10]">删除</el-button>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="tiHuoDanGuanLiWarp-body-table" :style="{height:detailsH}">
      <el-table
        :data="tableData"
        ref="shuXingTabRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        @row-click="dianjixuanzhong2"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="attrName"   label="属性名称" align="center"  ></el-table-column>
        <el-table-column prop="attrStandard"    label="字段名"  align="center" ></el-table-column>
        <el-table-column property="dataTypeName" label="数据类型"  align="center" ></el-table-column>
        <el-table-column prop="attrLength"    label="字段长度" align="center" ></el-table-column>
        <el-table-column prop="remark"  label="属性描述" align="center" ></el-table-column>
        <el-table-column prop="attrCode"    label="编码" align="center" ></el-table-column>
        <el-table-column prop="unitType"  label="计量单位" align="center" ></el-table-column>
        <el-table-column prop="isnotFlg"    label="是否必填" align="center" >
          <template slot-scope="scope"><div>
            <span  v-if="scope.row.isnotFlg == '1'">是</span>
            <span v-else-if="scope.row.isnotFlg == '0'">否</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="orderBy"  label="顺序" align="center" ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div style="text-align: right;">
      <el-pagination background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="attributePageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="attributePageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="attributeTotal">
      </el-pagination>
    </div>
    <!--新增spu-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addSpuMark"
    width="500px"
    center>
      <span>
         <el-form
          :model="changeFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          ref="changeFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
            <el-form-item label="类别名称:" prop="address" style="margin-top:10px;">
              <el-input  placeholder="" maxlength=""   v-model.trim="addSpuName" style="width:200px;"></el-input>
            </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="addSpuSubmit" v-if="addSpuBtn" :loading='addSpuLoading'>保存</el-button>
        <el-button type="primary" size='mini'  @click="changeSpuSubmit" v-if="changeSpuBtn" :loading='changeSpuLoading'>修改</el-button>
        <el-button @click="addSpuClose" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
    <!--新增spu属性-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addSpuShuXingMark"
    width="1200px"
    center>
      <span>
         <el-table
        :data="addShuXingtableData"
        ref="addShuXingtableData"
        border
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column prop="shuXingName"   label="属性名称" align="center"  >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="" v-model="scope.row.shuXingName" size="mini"></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="ziDuanName"    label="字段名"  align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="" v-model="scope.row.ziDuanName" onkeyup="var reg = /^[\d\_a-zA-Z]+$/;if(!reg.test(this.value)) this.value='';" size="mini" :disabled="changeDisabled"></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="dataType"    label="数据类型"  align="center" >
            <template slot-scope="scope"><div>
            <el-select v-model="scope.row.dataType" placeholder="请选择" @change="dateTypeChange" size="mini" :disabled="changeDisabled">
              <el-option
                v-for="(item,index) in dataTypeOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="ziDuanLength"    label="字段长度"  align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="" v-model="scope.row.ziDuanLength" onkeyup="this.value=this.value.replace(/[^\d\,]/g,'')"  size="mini" :disabled="ZiDuanLengthDisabled"></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="shuXingRemark"  label="属性描述" align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="" v-model="scope.row.shuXingRemark" size="mini"></el-input>
          </div></template>
        </el-table-column>
        <el-table-column prop="bianMa"    label="编码" align="center" >
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.bianMa" filterable placeholder="请选择" size="mini" :disabled="changeBianMaDisabled" clearable>
              <el-option
                v-for="(item,index) in bianMaOptions"
                :key="index"
                :label="item.showName2"
                :value="item.showName2">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="jiLiangDanWei"  label="计量单位" align="center" >
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.jiLiangDanWei" placeholder="请选择" size="mini" clearable>
              <el-option
                v-for="(item,index) in jiLiangDanWeiOptions"
                :key="index"
                :label="item.showName"
                :value="item.showName">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="isMust"    label="是否必填" align="center" >
          <template slot-scope="scope"><div>
            <el-select v-model="scope.row.isMust" placeholder="请选择" size="mini">
              <el-option
                v-for="item in isMustOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div></template>
        </el-table-column>
        <el-table-column prop="order"  label="顺序" align="center" >
          <template slot-scope="scope"><div>
            <el-input  placeholder="" maxlength="" v-model="scope.row.order" size="mini"></el-input>
          </div></template>
        </el-table-column>
      </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="addSpuShuXingSubmit" v-if="addShuXingShow" :loading='addShengChengLoading'>保存</el-button>
        <el-button type="primary" size='mini'  @click="changeSpuShuXingSubmit" v-if="changeShuXingShow" :loading='changeShengChengLoading'>修改</el-button>
        <el-button @click="addSpuShuXingClose" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  spuAdd, // 新增
  spuSearch, // 查询
  spuStatus, // spu状态
  spuUpdate, // spu修改
  spuAttributeList,   //spu属性列表
  spuAttributeAdd,   //spu属性新增
  spuAttributeUpdate, //spu属性修改
  seeGroupType,  // 下拉框数据
  skuCheckExist ,// 判断有无spu属性
  skuCheckSkuExist, // 判断sku有无数据
  spuDelete, // spu删除
  spuAttributeDelete, // spu属性删除
} from '@/api/spu'
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
       // 按钮
      btnFlg: [],
      btnIdArr: ["000P00JB001","000P00JB002","000P00JB003",
                "000P00JB004","000P00JB005","000P00JB006",
                "000P00JB007","000P00JB008","000P00JB009",
                "000P00JB00A","000P00JB00B"],
      title: '',
      h: '500px',
      detailsH: '200px',
      spuTotal: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        spuCode:'',
        spuName:'',
        createUser:'',
        validFlg:'',
        startTime:'',
        endTime:'',
        dateTime:[]
      },
      statusOptions: [{
          value: '1',
          label: '启用'
        }, {
          value: '0',
          label: '停用'
        }],
      // 新增spu
      addSpuMark:false,
      addSpuLoading:false,
      addSpuName:'',
      liuXiangOptions: [],
      changeFleetOptions: [],
      value: '',
      spuTableList: [],
      addSpuBtn:false,
      //新增spu属性
      addShuXingShow:false,// 新增属性保存按钮
      tableData:[],
      addSpuShuXingMark:false,
      addShuXingtableData:[{
        shuXingName:'',
        ziDuanLength:'',
        shuXingRemark:'',
        bianMa:'',
        jiLiangDanWei:'',
        isMust:'0',
        dataType:'',
        ziDuanName:'',
        order:''
      }],
      dataTypeOptions:[
        // {
        //   showName:'请选择',
        //   itemNo:''
        // }
      ],
      bianMaOptions:[],
      jiLiangDanWeiOptions:[],
      isMustOptions:[{
          value: '0',
          label: '否'
        }, {
          value: '1',
          label: '是'
        }
      ],
      // 修改
      changeBtnShow:true,
      changeShuXiangBtnShow:true,
      changeMark: false,
      addShengChengLoading: false,
      addFaBuLoading: false,
      changeSpuLoading:false,
      changeSpuId:'',
      changeSpuBtn:false,
      changeShengChengLoading:false,
      changeShuXingShow:false,// 修改属性保存按钮
      changeDisabled:false,
      ZiDuanLengthDisabled:false,
      changeBianMaDisabled:false,
       // 新增验证
      rules: {
        changeFleet: [
          { required: true, message: '车队不能为空', trigger: 'blur' }
        ],
        jiHuaShangXian: [
          { required: true, message: '自动生成计划上限不能为空', trigger: 'blur' }
        ]
      },
      changeFrom: {
        jiHuaDate: [],
        jiHuaDateStr: '',
        heTongBianHao: '',
        changeKeHuName: '',
        liuXiang: '',
        changeFleet: '',
        changeName: '',
        address: '',
        jiHuaShangXian: '',
        changeId: ''
      },
      cheDuiObj:{},
      newDateArr:[],
      xuanzhongArr:[],
      currentXQ:'',
      spuSelectData:[],
      selectListId:[],
      selectListGoods:null,
      defaultSelectedId:'',
      defaultSelectedSpuName:'',
      defaultSelectedSpuCode:'',
      attributePageNo:1,
      attributePageSize:10,
      attributeTotal:0,
      ziBiaoXuanZhongArr:[],
      spuId:'',
      shuXingId:'',
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.5 * pH - h - 110 + 'px'
    this.detailsH = 0.5 * pH - h2 - 70 + 'px'
  },
  created () {
    this.getSpuList()
    this.btnFlg = getBtn(this.btnIdArr, '/productManagement/spuManagement')
  },
  methods: {
    // 选择数据
    selectGoods(selection) {
      // this.spuSelectData = [];
      // this.selectListId = [];
      // this.spuSelectData = selection;
      // if (this.spuSelectData.length == 1) {
      //   this.selectListGoods = this.spuSelectData[0];
      // }
      // let arry = [];
      // selection.forEach((item) => {
      //   arry.push(item.id); //id数组
      //   arry = Array.from(new Set(arry)); //去重
      //   this.selectListId = arry.join(","); //获取全部货物id
      // });
    },
    // spu列表数据
    getSpuList(){
      spuSearch({
        pageNo:this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize,
        spuCode:this.searchFrom.spuCode,
        spuName:this.searchFrom.spuName,
        createUser:this.searchFrom.createUser,
        validFlg:this.searchFrom.validFlg,
        startTime:this.searchFrom.dateTime[0],
        endTime:this.searchFrom.dateTime[1],
      }).then(res =>{
        this.spuTableList = res.list
        this.spuTotal = res.total
        this.defaultSelectedId = this.spuTableList[0].id
        this.defaultSelectedSpuName = this.spuTableList[0].spuName
        this.defaultSelectedSpuCode = this.spuTableList[0].spuCode
        if(this.spuTableList !=[]){
          setTimeout(() => {
              this.$refs.spuTableList.setCurrentRow(this.$refs.spuTableList.data[0]);
              this.$refs.spuTableList.toggleRowSelection(this.$refs.spuTableList.data[0]);
            }, 10);
            if(this.spuTableList[0].validFlg == '1'){
              this.changeBtnShow = false
              this.changeShuXiangBtnShow = false
            }else{
              this.changeBtnShow = true
              this.changeShuXiangBtnShow = true
            }
        }
        this.getSpuAttributeList()
      }).catch(err =>{
        // DonMessage.error(err.message);
      })
    },
    // 点击主表选中需要修改的行
    dianjixuanzhong(row, column, event) {
      this.xuanzhongArr = [];
      this.xuanzhongArr = row;
      this.currentXQ = 1;
      this.$refs.spuTableList.toggleRowSelection(row);
      this.spuId = row.id
      this.getSpuAttributeList(); //子表数据
      if(row.validFlg == '1'){
        this.changeBtnShow = false
        this.changeShuXiangBtnShow = false
      }else{
        this.changeBtnShow = true
        this.changeShuXiangBtnShow = true
      }
    },
    // 点击子表选中需要修改的行
    dianjixuanzhong2(row, column, event){
      this.ziBiaoXuanZhongArr = []
      this.ziBiaoXuanZhongArr = row
      this.currentXQ = 1;
      this.shuXingId = row.id
      this.$refs.shuXingTabRef.toggleRowSelection(row);
    },
    // 新增spu
    addSpuClick(){
      this.addSpuName = ''
      this.title = '新增类别'
      this.addSpuMark = true
      this.addSpuBtn = true
      this.changeSpuBtn = false
    },
    // 新增spu保存
    addSpuSubmit(){
      this.addSpuLoading = true
      spuAdd({
        spuName:this.addSpuName
      }).then(res =>{
        DonMessage.success('添加成功！');
        this.getSpuList()
        this.addSpuLoading = false
        this.addSpuMark = false
        this.addSpuName = ''
      }).catch(err =>{
        this.addSpuLoading = false
        DonMessage.error(err.message);
      })
    },
    // 新增spu取消按钮
    addSpuClose(){
      this.addSpuMark = false
      this.addSpuName = ''
    },
    // 点击查询
    chaXun () {
      this.getSpuList()
    },
    // 点击重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        spuCode:'',
        spuName:'',
        createUser:'',
        validFlg:'',
        startTime:'',
        endTime:'',
        dateTime:[]
      },
      this.getSpuList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSpuList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSpuList()
    },
    // 点击启用，停用
    startOrStopClick(row){
      let status = ''
      if(row.validFlg == '0'){
        status = '1'
      }else{
        status = '0'
      }
      this.$confirm("是否确定此操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          spuStatus({
            id:row.id, //  字典表id
            validFlg:status
          })
            .then(res => {
              DonMessage.success("操作成功!")
              this.getSpuList()
            })
            .catch(err => {
              DonMessage.error(err.message);
            })
      })
        .catch(() => {})
    },
    // 点击spu管理修改按钮
    spuChangeClick(){
      // console.log(this.xuanZhongArr,'2222')
      // this.addSpuName = this.xuanzhongArr.spuName
      this.spuSelectData = this.$refs.spuTableList.selection
      if (this.spuSelectData.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else{
        this.addSpuMark = true
        this.title = '修改类别'
        this.addSpuBtn = false
        this.changeSpuBtn = true
        // this.addSpuName = this.xuanzhongArr.spuName
        // this.changeSpuId = this.xuanzhongArr.id
        this.spuSelectData.forEach((item,index) => {
          this.addSpuName = item.spuName
          this.changeSpuId = item.id
        });
      }
    },
    // 点击spu修改保存
    changeSpuSubmit(){
      this.changeSpuLoading = true
      spuUpdate({
        id:this.changeSpuId,
        spuName:this.addSpuName
      }).then(res =>{
        this.changeSpuLoading = false
        DonMessage.success("操作成功!")
        this.addSpuMark = false
        this.getSpuList()
      }).catch(err =>{
        this.changeSpuLoading = false
        DonMessage.error(err.message);
      })
    },
    // 点击spu删除按钮
    spuDelBtnClick () {
      let spuDelData = this.$refs.spuTableList.selection
      if (spuDelData.length < 1) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        skuCheckExist({
            spuId:this.xuanzhongArr.id || this.defaultSelectedId
          }).then(res =>{
            if(res > 0){
              DonMessage.error("此条数据不能删除");
            }else{
              this.$confirm("是否确定此操作？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  spuDelete({
                    id:this.spuId, //  字典表id  !=0 不让删
                  })
                    .then(res => {
                      DonMessage.success("操作成功!")
                      this.getSpuList()
                    })
                    .catch(err => {
                      DonMessage.error(err.message);
                    })
              })
                .catch(() => {})
            }
          })
      }
    },
    // 属性删除
    delShuXingClick(){
      let spuShuXingDelData = this.$refs.shuXingTabRef.selection
      if (spuShuXingDelData.length < 1) {
        this.$message.error('请选择一条数据进行操作！')
      } else {
        skuCheckSkuExist({
            spuId:this.xuanzhongArr.id || this.defaultSelectedId
          }).then(res =>{
            if(res > 0){
              DonMessage.error("此条数据不能删除");
            }else{
              this.$confirm("是否确定此操作？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  spuAttributeDelete({
                    id:this.shuXingId, //  字典表id  !=0 不让删 
                    spuId:this.xuanzhongArr.id || this.defaultSelectedId
                  })
                    .then(res => {
                      DonMessage.success("操作成功!")
                      this.getSpuAttributeList()
                    })
                    .catch(err => {
                      DonMessage.error(err.message);
                    })
              })
                .catch(() => {})
            }
          }).catch(err =>{
            DonMessage.error(err.message);
          })
      }
    },
    // 获取spu属性列表
    getSpuAttributeList(){
      spuAttributeList({
        spuId:this.xuanzhongArr.id || this.defaultSelectedId,
        pageNo:this.attributePageNo ,
        pageSize:this.attributePageSize
      }).then(res =>{
        this.tableData = res.list
        this.attributeTotal = res.total
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    // 子表分页
    handleSizeChange2(val){
      this.attributePageSize = val
      this.getSpuAttributeList()
    },
    handleCurrentChange2(val){
      this.attributePageNo = val
      this.getSpuAttributeList()
    },
    // 获取新增修改页面编码下拉框数据
    getSelectbianMaData(){
      seeGroupType({
        groupNo:'group_type',  //获取编码
      }).then(res =>{
        this.bianMaOptions = res
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    // 获取新增修改页面数据类型下拉框数据
    getSelectNumTypeData(){
      seeGroupType({
        groupNo:'field_type',  //数据类型
      }).then(res =>{
        this.dataTypeOptions = res
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    // 获取新增修改页面计量单位下拉框数据
    getSelectJiLiangData(){
      seeGroupType({
        groupNo:'unit_type',  //计量单位
      }).then(res =>{
        this.jiLiangDanWeiOptions = res
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    // 点击添加属性按钮
    addShuXIngClick(){
      this.addSpuShuXingMark = true
      this.title = '添加类别属性'
      this.addShuXingShow = true
      this.changeShuXingShow = false
      this.changeDisabled = false
      this.ZiDuanLengthDisabled = false
      this.changeBianMaDisabled = true
      this.getSelectbianMaData()
      this.getSelectNumTypeData()
      this.getSelectJiLiangData()
    },
    // 数据类型是文本时，编码允许选择
    dateTypeChange(selVal){
      if(selVal == '3'){
        this.changeBianMaDisabled = false
      }else{
        this.changeBianMaDisabled = true
        this.addShuXingtableData[0].bianMa = ''
      }
      if(selVal == '4'){
        this.ZiDuanLengthDisabled = true
        this.addShuXingtableData[0].ziDuanLength = ''
      }else{
        this.ZiDuanLengthDisabled = false
      }
      // console.log(selVal)
    },
    // 新增spu属性确认
    addSpuShuXingSubmit(){
      this.addShengChengLoading = true
      spuAttributeAdd({
        spuId:this.xuanzhongArr.id || this.defaultSelectedId,
        spuName:this.xuanzhongArr.spuName || this.defaultSelectedSpuName,
        spuCode:this.xuanzhongArr.spuCode || this.defaultSelectedSpuCode,
        attrName:this.addShuXingtableData[0].shuXingName,  // 属性名称
        attrStandard:this.addShuXingtableData[0].ziDuanName, // 字段名
        attrDatatype:this.addShuXingtableData[0].dataType,  // 数据类型
        attrLength:this.addShuXingtableData[0].ziDuanLength, //字段长度限制
        remark:this.addShuXingtableData[0].shuXingRemark,//属性描述
        attrCode:this.addShuXingtableData[0].bianMa,//属性编码
        unitType:this.addShuXingtableData[0].jiLiangDanWei,//计量单位
        isnotFlg:this.addShuXingtableData[0].isMust, //是否必填
        orderBy:this.addShuXingtableData[0].order,//顺序
      }).then(res =>{
        DonMessage.success("操作成功!")
        this.addShengChengLoading = false
        this.addSpuShuXingMark = false
        this.addShuXingtableData = [{
            shuXingName:'',
            ziDuanLength:'',
            shuXingRemark:'',
            bianMa:'',
            jiLiangDanWei:'',
            isMust:'0',
            dataType:'',
            ziDuanName:'',
            order:''
        }]
        this.getSpuAttributeList()
      }).catch(err =>{
        this.addShengChengLoading = false
        DonMessage.error(err.message);
      })
    },
    // 新增spu属性取消
    addSpuShuXingClose(){
      this.addSpuShuXingMark = false
        this.addShuXingtableData = [{
        shuXingName:'',
        ziDuanLength:'',
        shuXingRemark:'',
        bianMa:'',
        jiLiangDanWei:'',
        isMust:'0',
        dataType:'',
        ziDuanName:'',
        order:''
      }]
    },
    // 点击修改spu属性
    changeShuXingClick(){
      // this.ziBiaoXuanZhongArr = this.$refs.shuXingTabRef.selection
      if (this.ziBiaoXuanZhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else{
        this.addSpuShuXingMark = true
        this.title = '修改类别属性'
        this.changeShuXingShow = true
        this.addShuXingShow = false
        this.getSelectbianMaData()
        this.getSelectNumTypeData()
        this.getSelectJiLiangData()
        this.addShuXingtableData[0].shuXingName = this.ziBiaoXuanZhongArr.attrName  // 属性名称
        this.addShuXingtableData[0].ziDuanName = this.ziBiaoXuanZhongArr.attrStandard  // 字段名
        this.addShuXingtableData[0].dataType = this.ziBiaoXuanZhongArr.attrDatatype  // 数据类型
        this.addShuXingtableData[0].ziDuanLength = this.ziBiaoXuanZhongArr.attrLength // 字段长度限制
        this.addShuXingtableData[0].shuXingRemark = this.ziBiaoXuanZhongArr.remark // 属性描述
        this.addShuXingtableData[0].bianMa = this.ziBiaoXuanZhongArr.attrCode // 属性编码
        this.addShuXingtableData[0].jiLiangDanWei = this.ziBiaoXuanZhongArr.unitType // 计量单位
        this.addShuXingtableData[0].isMust = this.ziBiaoXuanZhongArr.isnotFlg // 是否必填
        this.addShuXingtableData[0].order = this.ziBiaoXuanZhongArr.orderBy //顺序
        skuCheckSkuExist({
        spuId:this.xuanzhongArr.id || this.defaultSelectedId
        }).then(res =>{
          if(res > 0 ){
            this.changeDisabled = true
            this.ZiDuanLengthDisabled = true
            this.changeBianMaDisabled = true
          }else{
            this.changeDisabled = false
            this.ZiDuanLengthDisabled = false
            this.changeBianMaDisabled = false
          }
          if(this.ziBiaoXuanZhongArr.attrDatatype != '3'){
            this.addShuXingtableData[0].bianMa = ''
            this.changeBianMaDisabled = true
          }else{
            this.changeBianMaDisabled = false
          }
          if(this.ziBiaoXuanZhongArr.attrDatatype == '4'){
            this.ZiDuanLengthDisabled = true
          }else{
            this.ZiDuanLengthDisabled = false
          }
        }).catch(err =>{
          DonMessage.error(err.message);
        })
      }
    },
    // 点击修改spu属性确定
    changeSpuShuXingSubmit(){
      this.changeShengChengLoading = true
      spuAttributeUpdate({
        id:this.ziBiaoXuanZhongArr.id,
        spuId:this.xuanzhongArr.id || this.defaultSelectedId,
        spuName:this.xuanzhongArr.spuName || this.defaultSelectedSpuName,
        spuCode:this.xuanzhongArr.spuCode || this.defaultSelectedSpuCode,
        attrName:this.addShuXingtableData[0].shuXingName,  // 属性名称
        attrStandard:this.addShuXingtableData[0].ziDuanName, // 字段名
        attrDatatype:this.addShuXingtableData[0].dataType,  // 数据类型
        attrLength:this.addShuXingtableData[0].ziDuanLength, //字段长度限制
        remark:this.addShuXingtableData[0].shuXingRemark,//属性描述
        attrCode:this.addShuXingtableData[0].bianMa,//属性编码
        unitType:this.addShuXingtableData[0].jiLiangDanWei,//计量单位
        isnotFlg:this.addShuXingtableData[0].isMust, //是否必填
        orderBy:this.addShuXingtableData[0].order,//顺序
      }).then(res =>{
        DonMessage.success("操作成功!")
        this.changeShengChengLoading = false
        this.addSpuShuXingMark = false
        this.addShuXingtableData = [{
            shuXingName:'',
            ziDuanLength:'',
            shuXingRemark:'',
            bianMa:'',
            jiLiangDanWei:'',
            isMust:'0',
            dataType:'',
            ziDuanName:'',
            order:''
        }]
        this.getSpuAttributeList()
      }).catch(err =>{
        this.changeShengChengLoading = false
        DonMessage.error(err.message);
      })
    },
    // 点击查看sku 
    seeSkuClick(row){
      skuCheckExist({
        spuId:row.id
      }).then(res =>{
        if(res != '0'){
          localStorage.setItem('spuId', row.id)
          localStorage.setItem('spuName', row.spuName)
          this.$router.push('/productManagement/skuManagement')
        }else{
          DonMessage.error("此数据没有类别属性，请添加属性再查看！");
        }
      }).catch(err =>{
        DonMessage.error(err.message);
      })
      // this.$router.push({
      //   name:'/skuManagement',
      //   params: {
      //     spuId:row.id
      //   }
      // })
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;
}
.inpBox .el-date-editor{
    width: 260px!important;
 }
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBox{
  margin-left: 10px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
.tiHuoDanGuanLiWarp-body-table {
      margin-top: 5px;
 }
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
